import { createReducer } from "@reduxjs/toolkit";
import { studentRetrieveUnsignedAttendanceSheets } from "./retrieve-unsigned-attendance-sheets";
import { signStudentAttendanceSheet } from "@academy-context/write/application/use-cases/student/attendance-sheet-signature/sign-student-attendance-sheet";
import { signAllStudentAttendanceSheets } from "@academy-context/write/application/use-cases/student/attendance-sheet-signature/sign-all-student-attendance-sheets";
import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<AttendanceSheetVM[]> = { fetching: "idle", data: [] };

export const unsignedAttendanceSheetsRetrievalReducer = createReducer<RetrievalState<AttendanceSheetVM[]>>(initialState, builder => {
  builder.addCase(studentRetrieveUnsignedAttendanceSheets.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrieveUnsignedAttendanceSheets.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrieveUnsignedAttendanceSheets.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  // When a single sheet is signed, remove it from the list
  builder.addCase(signStudentAttendanceSheet.fulfilled, (state, action) => {
    const signedSheetId = action.meta.arg.attendanceSheetId;
    return {
      ...state,
      data: state.data.filter(sheet => sheet.id !== signedSheetId),
    };
  });
  // When all sheets are signed, clear the list
  builder.addCase(signAllStudentAttendanceSheets.fulfilled, state => {
    return {
      ...state,
      data: [],
    };
  });
});
